import * as Api from '@/api/game'

const state={
};

const getters={
};

const mutations={
};

const actions={
    async CreateUserPrizePool(context,data){
        let res = await Api.create_user_prize_pool(data);
        return res.data;
    },
    async OpenPackage(context,data){
        let res = await Api.open_package(data);
        return res.data;
    },
    async CheckGameTicket(context,data){
        let res = await Api.check_game_ticket(data);
        return res.data;
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}
